import { FormConfig } from "@/components/forms/types";

export const dialog: FormConfig = {
  title: "Media",
  sections: [
    {
      title: "General",
      fields: [
        {
          type: "textarea",
          name: "description",
          label: "Description",
          rules: [requiredValidator],
          required: true,
        },
      ],
    },
  ],
};

export default {
  dialog,
};
